export const decodeEnv = (value) => {
    return Buffer.from(value, 'base64').toString('utf-8');
};